import { Component, OnInit, ElementRef } from '@angular/core';
import { HttpService } from '../../services/http-service/http.service';
import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../services/local-inteface-service/local-interface.service';
import { ValidationService } from '../../services/validation-service/validation.service';
import { StorageService } from '../../services/storege-service/storage.service';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tournament',
  templateUrl: './tournament.component.html',
  styleUrls: ['./tournament.component.scss']
})
export class TournamentHistoryComponent implements OnInit {

  tournamentListingData?;
  isLoading = false;
  selectedTab = 'Active'
  facilityId;


  constructor(
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private validationSrv: ValidationService,
    private storageSrv: StorageService,
    public router: Router,
    public route: ActivatedRoute,
    private elementRef: ElementRef

  ) { }

  ngOnInit(): void {
    this.validationSrv.validateAcess().then(async () => {
      this.facilityId = this.storageSrv.getFacilityId();
      this.isLoading = true
      await this.loadTournamentListingData();
      this.isLoading = false


    });
  }

  public totalRecords = 0;
  currentPage: number = 1;
  totalPages: number = 1;
  pageLimit: number = 10
  totalPageLimits: number[] = [5, 10, 20]

  loadTournamentListingData = (updatedPage?, updatedLimit?) => {
    const obj = {
      status: "history",
      // facilityId: this.facilityId,
      // admin:true,
      page: updatedPage || this.currentPage,
      limit: updatedLimit || this.pageLimit,
    }

    const params = new URLSearchParams(obj as any);
    const queryString = params.toString();
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getTournaments(queryString)
        .then(async res => {

          this.totalPages = res.data.content.count
          if (this.totalRecords <= 0) {
            this.totalRecords = res.data.content.count
          }

          this.tournamentListingData = { content: res.data.content.tournaments, count: this.totalRecords };

          this.isLoading = false;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          console.log(err);

        })
        .finally(() => {
          this.isLoading = false
        });
    });
  }


  onPaginationChange = async (page: number) => {
    this.currentPage = page;
    // this.filterQuery=""
    this.scrollToTop()

    await this.loadTournamentListingData(page)
  }

  onPageChange = async (updatedPage) => {
    if (updatedPage === this.pageLimit)
      return

    this.pageLimit = updatedPage
    this.currentPage = 1;
    await this.loadTournamentListingData(1, updatedPage)


  }


  getDays = (fromDate, toDate) => {
    const startDate = moment(fromDate);
    const endDate = moment(toDate);
    const daysDifference = endDate.diff(startDate, 'days') + 1;
    return daysDifference || ""
  }

  getTournamentStatus = (val) => {
    switch (val.toLowerCase()) {
      case 'registrationupcoming':
        return 'Registration Upcoming';
      case 'live':
        return 'Live';
      default:
        return val;
    }
  }

  getStartingDate = (val) => {
    return moment(val).format("ddd • D MMM") || ""
  }

  getTournamentLocation = (item) => {
    return item?.courts[0]?.nameEn || "Test Location"
  }

  getCategory = (val) => {
    let categoryString = ""
    for (let i of val) {
      categoryString = `${categoryString} ${i.category}`
    }
    categoryString.trim()
    return categoryString
  }

  tournamentClickHandler(data: object | any) {
    // this.router.navigate([`details/${data.id}`], { relativeTo: this.route });
  }

  addTournament() {
    // this.router.navigate([`editableDetails`], { relativeTo: this.route});
    this.router.navigate([`creation`], { relativeTo: this.route });
  }

  editTournament(data: object | any, event: Event) {
    event.stopPropagation();
    this.router.navigate([`editableDetails/${data.id}`], { relativeTo: this.route });
  }


  scrollToTop() {
    const htmlElement = this.elementRef.nativeElement.ownerDocument.documentElement;
    htmlElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

}


